import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';
import type { PaginatedResponse } from '@/shared/types/entity';
import type { BrokenSubscription, BrokenSubscriptionDetails, ProblemCodeOption } from '../types';

export const brokenSubscriptionsApi = {
  getList: async (params?: {
    page?: number;
    perPage?: number;
    search?: string;
    problemCode?: string;
    status?: string;
  }): Promise<PaginatedResponse<BrokenSubscription>> => {
    const response = await api.get<PaginatedResponse<BrokenSubscription>>(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.LIST,
      { params },
    );
    return response.data;
  },

  getProblemCodes: async (): Promise<ProblemCodeOption[]> => {
    const response = await api.get<ProblemCodeOption[]>(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.PROBLEM_CODES,
    );
    return response.data;
  },

  getDetails: async (shopifyCustomerId: number): Promise<BrokenSubscriptionDetails> => {
    const response = await api.get<BrokenSubscriptionDetails>(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.SHOW(shopifyCustomerId),
    );
    return response.data;
  },

  revalidate: async (shopifyCustomerId: number): Promise<BrokenSubscriptionDetails> => {
    const response = await api.post<BrokenSubscriptionDetails>(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.REVALIDATE(shopifyCustomerId),
    );
    return response.data;
  },

  updateShopifyLineQty: async (
    shopifyCustomerId: number,
    shopifyLineId: string,
    qty: number,
  ): Promise<void> => {
    await api.patch(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.SHOPIFY_LINE_UPDATE(shopifyCustomerId, shopifyLineId),
      { qty },
    );
  },

  deleteShopifyLine: async (shopifyCustomerId: number, shopifyLineId: string): Promise<void> => {
    await api.delete(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.SHOPIFY_LINE_DELETE(shopifyCustomerId, shopifyLineId),
    );
  },

  deleteShopifyDiscount: async (
    shopifyCustomerId: number,
    shopifyDiscountId: string,
  ): Promise<void> => {
    await api.delete(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.SHOPIFY_DISCOUNT_DELETE(
        shopifyCustomerId,
        shopifyDiscountId,
      ),
    );
  },

  updateProduct: async (
    shopifyCustomerId: number,
    productId: number,
    payload: { qty?: number; shopifyLineId?: string | null },
  ): Promise<void> => {
    await api.patch(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.PRODUCT_UPDATE(shopifyCustomerId, productId),
      payload,
    );
  },

  deleteProduct: async (shopifyCustomerId: number, productId: number): Promise<void> => {
    await api.delete(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.PRODUCT_DELETE(shopifyCustomerId, productId),
    );
  },

  deleteDiscount: async (shopifyCustomerId: number, discountId: number): Promise<void> => {
    await api.delete(
      API_ENDPOINTS.BROKEN_SUBSCRIPTIONS.DISCOUNT_DELETE(shopifyCustomerId, discountId),
    );
  },
};
